import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import {
  Box,
  Container
} from '@material-ui/core';

import EmployeeListResults from 'components/Employees/EmployeeListResults';

const mapStateToProps = (state) => ({
  activeUserId: state.activeUserId,
  employees: state.employees,
  expenses: state.expenses,
  idGen: state.idGen
});

const EmployeeList = (props) => (
  <>
    <Helmet>
      <title>Employees | Duot One</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container maxWidth={false}>
        <EmployeeListResults
          activeUserId={props.activeUserId}
          employees={props.employees}
          expenses={props.expenses}
          idGen={props.idGen}
        />
      </Container>
    </Box>
  </>
);

export default connect (mapStateToProps) (EmployeeList);